<template>
  <!------Start Of Bread crumb------------>
  <section class="about-header section-bg-3" > <!---- :style="{ marginTop: activePromotion ? '0' : '64px' }" -->
    <div class="container">
      <h1>events</h1>
    </div>
  </section>
  <!-------End Of Bread crumb ------------------>

  <!-------events content upcomming classes start----->
  <section class="container">
    <div class="row y-gap-20 justify-between items-center mt-60 mb-30">
      <div class="sectionTitle px-0" data-aos="fade-up" :data-aos-delay="150">
        <h2 class="sectionTitle__title">Upcoming Live Online Classes</h2>
        <p class="sectionTitle__text">
          Explore what's next and stay ahead with our curated list of upcoming
          opportunities.
        </p>
      </div>
    </div>
    <!----#1 Event card component------------>
    <div class="row event__card" data-aos="fade-up" :data-aos-delay="200">
      <!----#1 column 1 start------------->
      <div class="col-lg-7 event__card--first">
        <div class="d-flex items-center date">
          <div class="d-flex x-gap-5 items-center">14th Dec - 25th Jan</div>
          <div class="ml-20">10.00 AM - 4.00 PM</div>
        </div>

        <h2>Delay Analysis & EOT Claims</h2>
        <p>A hands-on bootcamp to master delay analysis & EOT claims.</p>

        <div class="row x-gap-10 y-gap-10 items-center pt-10">
          <div class="d-flex gap-3 teacher d-inline-flex align-items-center py-10 x-gap-5">
            <span class="d-inline-block mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                  stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
                <path
                  d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                  stroke="#94AD04" stroke-width="1.5" />
              </svg>
            </span>
            <span class="fw-500 d-inline-block instractor-name fw-500 text-16">
              Hosted by Ali Katary, Expert Engineer.
            </span>
          </div>
        </div>
      </div>
      <!----#1 column 1 end------------->

      <!----#2 column 2 start------------->
      <div class="col-md-6 col-lg-3 d-flex align-items-center justify-content-center mt-30 mt-md-0">
        <div class="coursesCard__image">
          <div class="px-5 d-inline-flex gap-10">
            <img src="../../assets/images/home/percent.svg" alt="image" />
            <span class="fw-500 text-20 discount">20% Off</span>
          </div>

          <div class="d-flex gap-3 d-inline-flex mb-10 align-items-center py-10 x-gap-5 price">
            <span class="d-inline-block fw-700 text-24 pt-1 price-orginial discount">$24.92</span>
            <span class="fw-400 d-inline-block pt-1 exprience text-20 ml-15">$32.90</span>
          </div>
        </div>
      </div>
      <!----#2 column 2 end------------->

      <!----#3 column 3 start for small------------->
      <div class="col-md-6 col-lg-2 d-flex align-items-center flex-column justify-content-center">
        <router-link class="button main-button main-button-1 d-inline-flex justify-center align-items-center"
          to="/events/1">
          learn more
          <span class="rotate-svg">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
              <path
                d="M11.086 5.65692L7.136 1.70692C6.95384 1.51832 6.85305 1.26571 6.85533 1.00352C6.8576 0.741321 6.96277 0.490508 7.14818 0.3051C7.33359 0.119692 7.5844 0.0145233 7.8466 0.0122448C8.1088 0.00996641 8.3614 0.110761 8.55 0.292919L14.207 5.94992C14.3002 6.04257 14.3741 6.15273 14.4246 6.27407C14.4751 6.3954 14.501 6.52551 14.501 6.65692C14.501 6.78833 14.4751 6.91844 14.4246 7.03977C14.3741 7.16111 14.3002 7.27127 14.207 7.36392L8.55 13.0209C8.45775 13.1164 8.34741 13.1926 8.2254 13.245C8.1034 13.2974 7.97218 13.325 7.8394 13.3262C7.70662 13.3273 7.57494 13.302 7.45205 13.2517C7.32915 13.2015 7.2175 13.1272 7.12361 13.0333C7.02971 12.9394 6.95546 12.8278 6.90518 12.7049C6.8549 12.582 6.8296 12.4503 6.83075 12.3175C6.8319 12.1847 6.85949 12.0535 6.9119 11.9315C6.96431 11.8095 7.04049 11.6992 7.136 11.6069L11.086 7.65692H1.5C1.23478 7.65692 0.98043 7.55156 0.792893 7.36403C0.605357 7.17649 0.5 6.92214 0.5 6.65692C0.5 6.3917 0.605357 6.13735 0.792893 5.94981C0.98043 5.76228 1.23478 5.65692 1.5 5.65692H11.086Z"
                fill="white" />
            </svg>
          </span>
        </router-link>
        <div class="event-alert d-flex mt-15 gap-10">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none">
              <path
                d="M15 4C17.1217 4 19.1566 4.84285 20.6569 6.34315C22.1571 7.84344 23 9.87827 23 12C23 14.1217 22.1571 16.1566 20.6569 17.6569C19.1566 19.1571 17.1217 20 15 20C12.8783 20 10.8434 19.1571 9.34315 17.6569C7.84285 16.1566 7 14.1217 7 12C7 9.87827 7.84285 7.84344 9.34315 6.34315C10.8434 4.84285 12.8783 4 15 4ZM15 6C13.4087 6 11.8826 6.63214 10.7574 7.75736C9.63214 8.88258 9 10.4087 9 12C9 13.5913 9.63214 15.1174 10.7574 16.2426C11.8826 17.3679 13.4087 18 15 18C16.5913 18 18.1174 17.3679 19.2426 16.2426C20.3679 15.1174 21 13.5913 21 12C21 10.4087 20.3679 8.88258 19.2426 7.75736C18.1174 6.63214 16.5913 6 15 6ZM14 8H15.5V11.78L17.83 14.11L16.77 15.17L14 12.4V8ZM2 18C1.73478 18 1.48043 17.8946 1.29289 17.7071C1.10536 17.5196 1 17.2652 1 17C1 16.7348 1.10536 16.4804 1.29289 16.2929C1.48043 16.1054 1.73478 16 2 16H5.83C6.14 16.71 6.54 17.38 7 18H2ZM3 13C2.73478 13 2.48043 12.8946 2.29289 12.7071C2.10536 12.5196 2 12.2652 2 12C2 11.7348 2.10536 11.4804 2.29289 11.2929C2.48043 11.1054 2.73478 11 3 11H5.05L5 12L5.05 13H3ZM4 8C3.73478 8 3.48043 7.89464 3.29289 7.70711C3.10536 7.51957 3 7.26522 3 7C3 6.73478 3.10536 6.48043 3.29289 6.29289C3.48043 6.10536 3.73478 6 4 6H7C6.54 6.62 6.14 7.29 5.83 8H4Z"
                fill="#EB5757"></path>
            </svg>
          </span>
          <span class="text-red-1 fw-500 text-16">Seats Filling Fast </span>
        </div>
      </div>
      <!------------------->
    </div>
    <!------#1 end of event card component------>
    <!-------#2 event card component -------->
    <!-----Start of row------------->
    <div class="row mt-30 event__card" data-aos="fade-up" :data-aos-delay="200">
      <!----#1 column 1 start------------->
      <div class="col-lg-7 event__card--first">
        <div class="d-flex items-center date">
          <div class="d-flex x-gap-5 items-center">14th Dec - 25th Jan</div>
          <div class="ml-20">10.00 AM - 4.00 PM</div>
        </div>

        <h2>Delay Analysis & EOT Claims</h2>
        <p>A hands-on bootcamp to master delay analysis & EOT claims.</p>

        <div class="row x-gap-10 y-gap-10 items-center pt-10">
          <div class="d-flex gap-3 teacher d-inline-flex align-items-center py-10 x-gap-5">
            <span class="d-inline-block mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                  stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
                <path
                  d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                  stroke="#94AD04" stroke-width="1.5" />
              </svg>
            </span>
            <span class="fw-500 d-inline-block instractor-name fw-500 text-16">
              Hosted by Ali Katary, Expert Engineer.
            </span>
          </div>
        </div>
      </div>
      <!----#1 column 1 end------------->

      <!----#2 column 2 start------------->
      <div class="col-md-6 col-lg-3 d-flex align-items-center">
        <div class="coursesCard__image">
          <div class="px-5 d-inline-flex gap-10">
            <img src="../../assets/images/home/percent.svg" alt="image" />
            <span class="fw-500 text-20 discount">20% Off</span>
          </div>

          <div class="d-flex gap-3 d-inline-flex mb-10 align-items-center py-10 x-gap-5 price">
            <span class="d-inline-block fw-700 text-24 pt-1 price-orginial discount">$24.92</span>
            <span class="fw-400 d-inline-block pt-1 exprience text-20 ml-15">$32.90</span>
          </div>
        </div>
      </div>
      <!----#2 column 2 end------------->

      <!----#3 column 3 start for small------------->
      <div class="col-md-6 col-lg-2 d-flex align-items-center flex-column justify-content-center">
        <router-link class="button main-button main-button-1 d-inline-flex justify-center align-items-center"
          to="/events/1">
          learn more
          <span class="rotate-svg">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
              <path
                d="M11.086 5.65692L7.136 1.70692C6.95384 1.51832 6.85305 1.26571 6.85533 1.00352C6.8576 0.741321 6.96277 0.490508 7.14818 0.3051C7.33359 0.119692 7.5844 0.0145233 7.8466 0.0122448C8.1088 0.00996641 8.3614 0.110761 8.55 0.292919L14.207 5.94992C14.3002 6.04257 14.3741 6.15273 14.4246 6.27407C14.4751 6.3954 14.501 6.52551 14.501 6.65692C14.501 6.78833 14.4751 6.91844 14.4246 7.03977C14.3741 7.16111 14.3002 7.27127 14.207 7.36392L8.55 13.0209C8.45775 13.1164 8.34741 13.1926 8.2254 13.245C8.1034 13.2974 7.97218 13.325 7.8394 13.3262C7.70662 13.3273 7.57494 13.302 7.45205 13.2517C7.32915 13.2015 7.2175 13.1272 7.12361 13.0333C7.02971 12.9394 6.95546 12.8278 6.90518 12.7049C6.8549 12.582 6.8296 12.4503 6.83075 12.3175C6.8319 12.1847 6.85949 12.0535 6.9119 11.9315C6.96431 11.8095 7.04049 11.6992 7.136 11.6069L11.086 7.65692H1.5C1.23478 7.65692 0.98043 7.55156 0.792893 7.36403C0.605357 7.17649 0.5 6.92214 0.5 6.65692C0.5 6.3917 0.605357 6.13735 0.792893 5.94981C0.98043 5.76228 1.23478 5.65692 1.5 5.65692H11.086Z"
                fill="white" />
            </svg>
          </span>
        </router-link>
        <div class="event-alert d-flex mt-15 gap-10">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none">
              <path
                d="M15 4C17.1217 4 19.1566 4.84285 20.6569 6.34315C22.1571 7.84344 23 9.87827 23 12C23 14.1217 22.1571 16.1566 20.6569 17.6569C19.1566 19.1571 17.1217 20 15 20C12.8783 20 10.8434 19.1571 9.34315 17.6569C7.84285 16.1566 7 14.1217 7 12C7 9.87827 7.84285 7.84344 9.34315 6.34315C10.8434 4.84285 12.8783 4 15 4ZM15 6C13.4087 6 11.8826 6.63214 10.7574 7.75736C9.63214 8.88258 9 10.4087 9 12C9 13.5913 9.63214 15.1174 10.7574 16.2426C11.8826 17.3679 13.4087 18 15 18C16.5913 18 18.1174 17.3679 19.2426 16.2426C20.3679 15.1174 21 13.5913 21 12C21 10.4087 20.3679 8.88258 19.2426 7.75736C18.1174 6.63214 16.5913 6 15 6ZM14 8H15.5V11.78L17.83 14.11L16.77 15.17L14 12.4V8ZM2 18C1.73478 18 1.48043 17.8946 1.29289 17.7071C1.10536 17.5196 1 17.2652 1 17C1 16.7348 1.10536 16.4804 1.29289 16.2929C1.48043 16.1054 1.73478 16 2 16H5.83C6.14 16.71 6.54 17.38 7 18H2ZM3 13C2.73478 13 2.48043 12.8946 2.29289 12.7071C2.10536 12.5196 2 12.2652 2 12C2 11.7348 2.10536 11.4804 2.29289 11.2929C2.48043 11.1054 2.73478 11 3 11H5.05L5 12L5.05 13H3ZM4 8C3.73478 8 3.48043 7.89464 3.29289 7.70711C3.10536 7.51957 3 7.26522 3 7C3 6.73478 3.10536 6.48043 3.29289 6.29289C3.48043 6.10536 3.73478 6 4 6H7C6.54 6.62 6.14 7.29 5.83 8H4Z"
                fill="#EB5757"></path>
            </svg>
          </span>
          <span class="text-red-1 fw-500 text-16">Seats Filling Fast </span>
        </div>
      </div>
      <!------------------->
    </div>
    <!-------#2 end of event card component----->
  </section>
  <!-------events content upcomming classes End----->

  <!-------past classes start----->
  <section class="container">
    <div class="row y-gap-20 justify-between items-center mt-60 mb-30" data-aos="fade-up" :data-aos-delay="250">
      <div class="sectionTitle px-0">
        <h2 class="sectionTitle__title">Past Live Online Classes</h2>
        <p class="sectionTitle__text">
          Look back on our most memorable moments and impactful sessions.
        </p>
      </div>
    </div>
    <!----#1 Event card component------------>
    <div class="row event__card">
      <!----#1 column 1 start------------->
      <div class="col-lg-10 event__card--first" data-aos="fade-up" :data-aos-delay="260">
        <div class="d-flex items-center date">
          <div class="d-flex x-gap-5 items-center text-muted">
            14th Dec - 25th Jan
          </div>
          <div class="ml-20 text-muted">10.00 AM - 4.00 PM</div>
        </div>

        <h2>Delay Analysis & EOT Claims</h2>
        <p>A hands-on bootcamp to master delay analysis & EOT claims.</p>

        <div class="row x-gap-10 y-gap-10 items-center pt-10">
          <div class="d-flex gap-3 teacher d-inline-flex align-items-center py-10 x-gap-5">
            <span class="d-inline-block mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                  stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
                <path
                  d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                  stroke="#94AD04" stroke-width="1.5" />
              </svg>
            </span>
            <span class="fw-500 d-inline-block instractor-name fw-500 text-16">
              Hosted by Ali Katary, Expert Engineer.
            </span>
          </div>
        </div>
      </div>
      <!----#1 column 1 end------------->

      <!----#2 column 2 start------------->
      <div class="col-md-6 col-lg-2 d-flex align-items-center flex-column justify-content-center">
        <button class="button disabled" disabled>Event Ended</button>
      </div>
      <!------------------->
    </div>
    <!------#1 end of event card component------>

    <!-------#2 event card component -------->
    <div class="row event__card mt-25" data-aos="fade-up" :data-aos-delay="270">
      <!----#1 column 1 start------------->
      <div class="col-lg-10 event__card--first">
        <div class="d-flex items-center date">
          <div class="d-flex x-gap-5 items-center text-muted">
            14th Dec - 25th Jan
          </div>
          <div class="ml-20 text-muted">10.00 AM - 4.00 PM</div>
        </div>

        <h2>Delay Analysis & EOT Claims</h2>
        <p>A hands-on bootcamp to master delay analysis & EOT claims.</p>

        <div class="row x-gap-10 y-gap-10 items-center pt-10">
          <div class="d-flex gap-3 teacher d-inline-flex align-items-center py-10 x-gap-5">
            <span class="d-inline-block mb-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                  stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
                <path
                  d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                  stroke="#94AD04" stroke-width="1.5" />
              </svg>
            </span>
            <span class="fw-500 d-inline-block instractor-name fw-500 text-16">
              Hosted by Ali Katary, Expert Engineer.
            </span>
          </div>
        </div>
      </div>
      <!----#1 column 1 end------------->

      <!----#2 column 2 start------------->
      <div class="col-md-6 col-lg-2 d-flex align-items-center flex-column justify-content-center">
        <button class="button disabled" disabled>Event Ended</button>
      </div>
      <!------------------->
    </div>
    <!-------#2 end of event card component----->
  </section>
  <!-------past classes end----->
</template>

<script>
import AOS from "aos";
export default {
  mounted() {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>
